import React from 'react'
import { Wrapper } from './styles'
import { useSelector } from 'react-redux'
import { productsSelector, categoriesSelector, usersSelector, themeSelector } from 'src/state/selectors'
import { isPaying, getProductLimit } from '@meniudigital/shared'
import { useNavigate } from 'react-router-dom'
import { Screen } from 'src/screens'
import Button from 'src/global/Button'

export default function MenuStatsPanel() {
  const { list: products } = useSelector(productsSelector)
  const { list: categories } = useSelector(categoriesSelector)
  const { user } = useSelector(usersSelector)
  const navigate = useNavigate()

  const isPayingUser = isPaying(user)
  const showLimit = !isPayingUser
  const productCount = products?.length || 0
  const productLimit = getProductLimit(user)
  const isCloseToOrOverLimit = productCount >= productLimit * 0.6
  const { isDark } = useSelector(themeSelector)

  // Redness starts at limit - 30 and reaches full red at limit - 5
  const rednessStartThreshold = productLimit - 30
  const fullRedThreshold = productLimit - 5

  // Grayscale starts at 0 until rednessStartThreshold, then grows to full red at fullRedThreshold
  const grayscaleRatio =
    showLimit && productCount > rednessStartThreshold
      ? Math.min((productCount - rednessStartThreshold) / (fullRedThreshold - rednessStartThreshold), 1)
      : 0

  // Brightness goes from 0.4 to 1
  const brightness = 0.4 + 0.6 * grayscaleRatio

  return (
    <Wrapper>
      <label>Meniul tău</label>
      <div className="content">
        <div className="stat">
          <div className="value">
            {isPayingUser ? (
              productCount
            ) : (
              <span
                style={{
                  color: 'hsl(5, 100%, 56%)',
                  filter: `grayscale(${1 - grayscaleRatio}) brightness(${isDark ? 1.5 : brightness})`,
                }}
              >
                {productCount}
              </span>
            )}
            {showLimit && <span className="limit"> / {productLimit}</span>}
          </div>
          <div className="label">Produse</div>
        </div>
        <div className="stat">
          <div className="value">{categories?.length || 0}</div>
          <div className="label">Categorii</div>
        </div>
      </div>
      {isCloseToOrOverLimit && !isPayingUser && (
        <div className="actions">
          <Button text="Alege un abonament" onClick={() => navigate(Screen.RenewSubscription)} />
        </div>
      )}
    </Wrapper>
  )
}
